export default "__VITE_ASSET__CZb2X72r__"